module.exports = __webpack_public_path__ + "img/feature_2.5b96ad49.webp";